import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles(() => ({
  container: {
    padding: "0px 25px",
  },
}));
